<template>
    <div class="main">
        <myheader></myheader>
        <div class="mains flex">
            <myleft></myleft>
            <div class="right">
                <div class="top flex">
                    <div class="btn flex">
                        <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd = true">新增</el-button>
                        <el-button type="danger" icon="el-icon-delete" size="small" @click="deleteSelect">删除选中项</el-button>
                    </div>
                    <el-form :inline="true" :model="formInline" :rules="rules" ref="formInline" class="demo-form-inline flex">
                        <el-form-item prop="name">
                            <el-input v-model="formInline.name" @input="handlerChange" placeholder="请输入账户名称" prefix-icon="el-icon-search"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submitForm('formInline')">搜索</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <!-- 新增账户 -->
                <el-dialog :title="title" :visible.sync="handleAdd" width="500px" center @close="dialogClose">
                    <el-form :model="form" :rules="addrules" ref="form" label-width="120px">
                        <el-input v-model="form.id" autocomplete="off" style="display: none;"></el-input>
                        <el-form-item prop="name" label="账户名称：">
                            <el-input v-model="form.name" autocomplete="off" placeholder="请输入账户名称" style="width: 290px;"></el-input>
                        </el-form-item>
                        <el-form-item prop="card" label="账号/卡号：">
                            <el-input v-model="form.card" autocomplete="off" placeholder="请输入账号/卡号" style="width: 290px;"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="handleAdd = false">取消</el-button>
                        <el-button type="primary" @click="submitFormAdd('form')" v-if="!handleEditBtn">确认</el-button>
                        <el-button type="primary" @click="submitFormEdit('form')" v-else>确认</el-button>
                    </div>
                </el-dialog>
                <div class="bot">
                    <el-table
                        ref="singleTable"
                        v-loading.fullscreen.lock="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
                        :data="tableData"
                        border
                        stripe
                        style="width: 100%"
                        max-height="95%"
                        :default-sort = "{prop: 'id', order: 'descending'}"
                        @selection-change="handleSelectionChange">
                        <el-table-column
                        type="selection"
                        width="113">
                        </el-table-column>
                        <el-table-column
                        fixed
                        prop="id"
                        label="ID"
                        width="113">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="账户名称">
                        </el-table-column>
                        <el-table-column
                        prop="card"
                        label="账号/卡号">
                        </el-table-column>
                        <el-table-column
                        prop="createtime"
                        :formatter="dateFormat"
                        label="时间">
                        </el-table-column>
                        <el-table-column
                        fixed="right"
                        label="操作"
                        width="150">
                        <template slot-scope="scope">
                            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                            <el-button @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
                        </template>
                        </el-table-column>
                    </el-table>
                    <div class="page">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="page"
                            :page-size="per_page"
                            layout="total, prev, pager, next, jumper"
                            :total="total"
                            :pager-count="5">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </template>

  <script>
    import { basis_account_index, basis_account_add, basis_account_edit, basis_account_del } from "@/api";
    import myheader from "@/components/common/header";
    import myleft from "@/components/common/left";
      export default {
          data () {
              return {
                // 新增报告模板弹窗默认隐藏
                title: '新增账户',
                handleAdd: false,
                handleEditBtn: false,
                form: {
                    id: '',
                    name: '',
                    card: ''
                },
                addrules: {
                    name: [
                        { required: true, message: '请输入账户名称', trigger: 'blur' }
                    ],
                    card: [
                        { required: true, message: '请输入账号/卡号', trigger: 'blur' }
                    ]
                },
                // 筛选
                formInline: {
                    name: ''
                },
                rules: {
                    name: [
                        { required: true, message: '请输入模板名称', trigger: 'blur' }
                    ]
                },
                // 数据列表
                loading: false,
                tableData: [],
                total: 0,
                per_page: 10, //每页多少数据
                page: 1
              }
            },
            components: {
                myheader: myheader,
                myleft: myleft
            },
            methods: {
                // 列表
                basisAccountIndex() {
                    this.loading = true;
                    basis_account_index().then((res) => {
                        // console.log(res.data.data);
                        this.loading = false;
                        if (res.data.code == 1) {
                            this.tableData = res.data.data.data;
                            this.total = res.data.data.total // 数据总条数
                        }
                    });
                },
                // 删除选中项
                deleteSelect() {
                    this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                            
                        var val = this.multipleSelection;
                        var multipleSelection = val.map(item => item['id']).join(','); // 勾选值数组转字符串

                        basis_account_del({
                            ids: multipleSelection
                        }).then(res => {
                            // console.log(res);
                            if (res.data.code == 1) {
                                this.page = 1;
                                this.basisAccountIndex(); // 调用数据列表函数
                            }
                        }).catch(error => {
                            console.log(error);
                        });

                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        });
                        }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });          
                    });
                },
                // 筛选
                submitForm(formName) {
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            // console.log(this.formInline.name);
                            this.loading = true;
                            basis_account_index({
                                params: {
                                    name: this.formInline.name,
                                    page: this.page
                                }
                            }).then((res) => {
                                // console.log(res.data.data);
                                this.loading = false;
                                if (res.data.code == 1) {
                                    this.tableData = res.data.data.data;
                                    this.total = res.data.data.total // 数据总条数
                                }
                            });
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });
                },
                // 搜索框输入数据为空显示初始数据
                handlerChange(e) {
                    // console.log(e);
                    if (e == '') {
                        this.basisAccountIndex(); // 调用数据列表函数
                    }
                },
                // 当选择项发生变化时会触发该事件
                handleSelectionChange(val) {
                    this.multipleSelection = val;
                    // var multipleSelection = val.map(item => item['id']).join(','); // 勾选值数组转字符串
                    // console.log(multipleSelection)
                },
                // 新增账户
                submitFormAdd(formName) {
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            console.log(this.form.name,this.form.card);
                            basis_account_add({
                                name: this.form.name,
                                card: this.form.card
                            }).then((res) => {
                                // console.log(res);
                                if (res.data.code == 1) {
                                    this.page = 1;
                                    this.handleAdd = false;
                                    this.basisAccountIndex(); // 调用数据列表函数
                                }
                                this.$message({
                                    type: 'success',
                                    message: '添加成功'
                                });
                            });
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });
                },
                // 行数据编辑
                handleEdit(row) {
                    console.log(row);
                    this.handleAdd = true;
                    this.handleEditBtn = true; // 判断是是新增还是编辑
                    this.title = '编辑账户';
                    this.form.id = row.id;
                    this.form.name = row.name;
                    this.form.card = row.card
                },
                // 编辑账户
                submitFormEdit(formName) {
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            // console.log(this.form.id,this.form.name,this.form.card);
                            basis_account_edit({
                                id: this.form.id,
                                name: this.form.name,
                                card: this.form.card
                            }).then((res) => {
                                // console.log(res);
                                if (res.data.code == 1) {
                                    this.page = 1;
                                    this.handleAdd = false;
                                    this.basisAccountIndex(); // 调用数据列表函数
                                }
                                this.$message({
                                    type: 'success',
                                    message: '修改成功'
                                });
                            });
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });
                },
                // dislog弹窗关闭清除数据以及验证
                dialogClose() {
                    this.title = '新增账户';
                    this.$refs['form'].resetFields(); // 清除验证提示文字
                    this.form.name = '';
                    this.form.card = '';
                },
                // 行数据删除
                handleDelete(row) {
                    // console.log(row.id);
                    this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {

                        basis_account_del({
                            ids: row.id
                        }).then(res => {
                            // console.log(res);
                            if (res.data.code == 1) {
                                this.page = 1;
                                this.basisAccountIndex(); // 调用数据列表函数
                            }
                        }).catch(error => {
                            console.log(error);
                        });
                        
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        });
                        }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });          
                    });
                },
                // 每页条数
                handleSizeChange(val) {
                    console.log(`每页 ${val} 条`);
                },
                // 当前页
                handleCurrentChange(page) {
                    // console.log(`当前页: ${page}`);
                    this.loading = true;
                    basis_account_index({
                        params: { page }
                    }).then((res) => {
                        // console.log(res.data.data);
                        this.loading = false;
                        if (res.data.code == 1) {
                            this.tableData = res.data.data.data;
                        }
                    });
                },
                // 时间戳转日期格式
                dateFormat(row) {
                    // console.log(row.createtime*1000)
                    let data = row.createtime * 1000
                    let dtime = new Date(data)
                    const year = dtime.getFullYear()
                    let month = dtime.getMonth() + 1
                    if (month < 10) {
                        month = '0' + month
                    }
                    let day = dtime.getDate()
                    if (day < 10) {
                        day = '0' + day
                    }
                    let hour = dtime.getHours()
                    if (hour < 10) {
                        hour = '0' + hour
                    }
                    let minute = dtime.getMinutes()
                    if (minute < 10) {
                        minute = '0' + minute
                    }
                    let second = dtime.getSeconds()
                    if (second < 10) {
                        second = '0' + second
                    }
                    return year+ '-' + month+ '-' + day + ' ' + hour + ':' + minute + ':' + second
                }
            },
            created() {
                this.basisAccountIndex() // 列表
            },
            // 解决表格fixed错位问题
            updated() {
                if (this.$refs.singleTable && this.$refs.singleTable.doLayout) {
                    this.$refs.singleTable.doLayout()
                }
            }
      }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style>
      .el-upload-dragger .el-upload__text{
        font-size: 12px;
        line-height: 24px;
        color: #C3C5CA;
      }
      .el-upload__tip{
        margin-top: 0;
        line-height: normal;
      }
      .el-dialog__body .el-form-item:last-child{
        margin-bottom: 0;
      }
      .upload-demo .el-upload-dragger{
        width: 198px!important;
      }
  </style>
  


// WEBPACK FOOTER //
// src/components/hkaccount.vue